import { FetchTradesResponse } from "./types";
import axiosInstance from "../axiosInstance";

export const fetchTrades = async (): Promise<FetchTradesResponse> => {
  const response = await axiosInstance.get<FetchTradesResponse>(
    "/api/private/trades",
  );
  return response.data;
};
